/*
 * Copyright (c) Schrocken Inc.
 * Author: Harish D
 * File Description: Reducer file for RM/PM
 */

import {
  CMO_FETCH_RM_AVAILABILITY,
  CMO_ADD_RM_AVAILABILITY,
  CMO_RM_STATUS_LIST,
  CMO_UPDATE_RM,
  CMO_FETCH_PM_AVAILABILITY,
  CMO_ADD_PM_AVAILABILITY,
  CMO_FETCH_PM_STATUSES,
  CMO_UPDATE_PM
} from "../../actions/types";

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case CMO_FETCH_RM_AVAILABILITY:
      return {
        ...state,
        rmAvailable: action.payload,
        rmAdded: false,
        rmUpdated: false
      };
    case CMO_ADD_RM_AVAILABILITY:
      return {
        ...state,
        rmAdded: action.payload
      };
    case CMO_RM_STATUS_LIST:
      return {
        ...state,
        rmStatuses: action.payload
      };
    case CMO_UPDATE_RM:
      return {
        ...state,
        rmUpdated: action.payload
      };
    // PM Reducers
    case CMO_FETCH_PM_AVAILABILITY:
      return {
        ...state,
        pmAvailable: action.payload,
        pmAdded: false,
        pmUpdated: false
      };
    case CMO_ADD_PM_AVAILABILITY:
      return {
        ...state,
        pmAdded: action.payload
      };
    case CMO_FETCH_PM_STATUSES:
      return {
        ...state,
        pmStatuses: action.payload
      };
    case CMO_UPDATE_PM:
      return {
        ...state,
        pmUpdated: action.payload
      };
    default:
      return state;
  }
}
